import template from "./bModalTermsOfUse.html";

export function bModalTermsOfUseDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    scope: {
      version: "=",
      content: "=",
      createdAt: "=",
      visibility: "=",
      user: "="
    },
    controller: bModalTermsOfUseController,
    controllerAs: 'bModalTermsOfUse',
    bindToController: true
  };

  return directive;
}

class bModalTermsOfUseController {
  constructor ($scope, Auth) {
    'ngInject';

    this.$scope = $scope;
    this.Auth = Auth;
    this.contentDisplayed = "";
    this.language = 'english';
    this.state = 'loading';

    this.$scope.$watch(
      () => this.content,
      loadedContent => {
        if (loadedContent) {
          this.state = 'loaded';
          this.contentDisplayed = loadedContent['english'];
        }
      }
    );
  }

  acceptTermsOfUse() {
    this.error = null;
    this.state = 'loading';
    this.Auth.acceptTermsOfUse().then(
      (token) => {
        this.state = 'loaded';
        this.Auth.setupLogin(token.data);
        this.visibility = false;
        this.$scope.$emit('termsAccepted', true);
      },
      (error) => {
        this.error = error;
        this.state = 'loaded';
      }
    );
  }

  switchLanguage(language) {
    this.language = language;
    this.contentDisplayed = this.content[language];
  }
}
